import { instance } from "apis/interceptor";
import { ResponseType } from "apis/meetings/meeting-reservation";
import { TFilter, TMeetingDataTable, TMetaData } from "types/analytics.types";

//INFO: 예약 현황 데이터 메타데이터 조회
export const getMeetingAnalyticsMetaData = async (): Promise<ResponseType<TMetaData[]>> => {
  try {
    const res = await instance.get("/analytics/meeting/datatable/event/metadata");
    return { success: true, data: res.data.content };
  } catch (error) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

export type TMeetingDataTableRes = {
  totalSearchNumber: number;
  totalPageNumber: number;
  nowPageNumber: number;
  meetingDashboards: TMeetingDataTable[];
};

//INFO: 예약 현황 데이터 조회
export const getMeetingAnalyticsData = async (
  page: number,
  period: { start: string; end: string },
  filters: TFilter[]
): Promise<ResponseType<TMeetingDataTableRes>> => {
  try {
    const res = await instance.post("/analytics/meeting/datatable/event", {
      page,
      period,
      filters,
    });
    return { success: true, data: res.data };
  } catch (error) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};
